import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function PrivacyPage({ t }) {
  const css = `
.privacy-page {
  max-width: 760px;
  margin: 0 auto;
  padding: 3rem 2rem 5rem;
  flex: 1;
}
.privacy-hero {
  margin-bottom: 3rem;
}
.privacy-eyebrow {
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.14em; color: ${t.textMuted};
  font-family: 'JetBrains Mono', monospace; margin-bottom: 10px;
}
.privacy-h1 {
  font-size: clamp(28px, 4vw, 42px); font-weight: 800;
  letter-spacing: -0.03em; color: ${t.textPrimary};
  margin-bottom: 14px; line-height: 1.1;
}
.privacy-h1 span {
  background: linear-gradient(135deg, #F05A41 0%, #D8A056 100%);
  -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
}
.privacy-hero-sub {
  font-size: 15px; color: ${t.textSecondary}; line-height: 1.7;
  max-width: 600px; margin-bottom: 24px;
}
.privacy-badges {
  display: flex; gap: 10px; flex-wrap: wrap;
}
.privacy-badge {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 20px;
  font-size: 12px; font-weight: 700; font-family: 'JetBrains Mono', monospace;
  border: 1px solid rgba(240,90,65,0.25);
  background: rgba(240,90,65,0.07); color: ${t.textAccent};
}
.privacy-card {
  background: ${t.bgPanel}; border: 1px solid ${t.border};
  border-radius: 16px; padding: 28px 28px; margin-bottom: 16px;
  position: relative; overflow: hidden;
}
.privacy-card::before {
  content: ''; position: absolute; top: 0; left: 0; right: 0; height: 2px;
  background: linear-gradient(90deg, #F05A41, #D8A056);
}
.privacy-card-icon {
  width: 44px; height: 44px; border-radius: 12px; margin-bottom: 16px;
  background: linear-gradient(135deg, rgba(240,90,65,0.12), rgba(216,160,86,0.12));
  display: flex; align-items: center; justify-content: center; font-size: 22px;
}
.privacy-card-title {
  font-size: 17px; font-weight: 700; color: ${t.textPrimary};
  margin-bottom: 10px; letter-spacing: -0.02em;
}
.privacy-card p {
  font-size: 13px; color: ${t.textSecondary}; line-height: 1.75; margin-bottom: 10px;
}
.privacy-card p:last-child { margin-bottom: 0; }
.privacy-card ul {
  margin: 8px 0 10px 0; padding-left: 0; list-style: none;
  display: flex; flex-direction: column; gap: 6px;
}
.privacy-card ul li {
  font-size: 13px; color: ${t.textSecondary}; line-height: 1.6;
  padding-left: 20px; position: relative;
}
.privacy-card ul li::before {
  content: '✓'; position: absolute; left: 0;
  color: #22c55e; font-weight: 700; font-size: 12px;
}
.privacy-card code {
  background: ${t.bgInput}; border: 1px solid ${t.border};
  border-radius: 5px; padding: 1px 7px;
  font-family: 'JetBrains Mono', monospace; font-size: 12px;
  color: ${t.textAccent};
}
.privacy-section-title {
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.14em; color: ${t.textMuted};
  font-family: 'JetBrains Mono', monospace; margin: 36px 0 14px;
}
.privacy-verifier {
  background: ${t.bgPanel}; border: 1px solid ${t.border};
  border-radius: 14px; padding: 20px 24px; margin-bottom: 16px;
}
.privacy-verifier-title {
  font-size: 14px; font-weight: 700; color: ${t.textPrimary}; margin-bottom: 8px;
}
.privacy-verifier-steps {
  counter-reset: step;
  list-style: none; padding: 0; margin: 0;
  display: flex; flex-direction: column; gap: 8px;
}
.privacy-verifier-steps li {
  counter-increment: step;
  display: flex; align-items: flex-start; gap: 12px;
  font-size: 13px; color: ${t.textSecondary}; line-height: 1.6;
}
.privacy-verifier-steps li::before {
  content: counter(step);
  min-width: 22px; height: 22px; border-radius: 50%;
  background: linear-gradient(135deg, #F05A41, #D8A056);
  color: #fff; font-size: 11px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0; margin-top: 1px;
}
.privacy-third-party-row {
  display: flex; align-items: flex-start; justify-content: space-between;
  gap: 16px; padding: 14px 0; border-bottom: 1px solid ${t.border};
}
.privacy-third-party-row:last-child { border-bottom: none; padding-bottom: 0; }
.privacy-tpr-name { font-size: 13px; font-weight: 700; color: ${t.textPrimary}; margin-bottom: 3px; }
.privacy-tpr-desc { font-size: 12px; color: ${t.textMuted}; line-height: 1.5; max-width: 400px; }
.privacy-tpr-badge {
  font-size: 10px; font-weight: 700; padding: 3px 9px; border-radius: 20px;
  white-space: nowrap; flex-shrink: 0;
  font-family: 'JetBrains Mono', monospace; margin-top: 2px;
}
.badge-external  { background: rgba(216,160,86,0.12); color: #D8A056; border: 1px solid rgba(216,160,86,0.25); }
.badge-cdn       { background: rgba(99,215,226,0.10); color: #63d7e2; border: 1px solid rgba(99,215,226,0.20); }
.badge-analytics { background: rgba(100,116,139,0.12); color: ${t.textMuted}; border: 1px solid ${t.border}; }
.privacy-footer-nav {
  display: flex; gap: 20px; flex-wrap: wrap;
  padding-top: 28px; border-top: 1px solid ${t.border}; margin-top: 36px;
}
.privacy-footer-nav a {
  font-size: 13px; color: ${t.textAccent}; text-decoration: none; font-weight: 600;
  transition: opacity 0.15s;
}
.privacy-footer-nav a:hover { opacity: 0.75; }
@media (max-width: 600px) {
  .privacy-page { padding: 2rem 1.25rem 4rem; }
  .privacy-card { padding: 20px 18px; }
  .privacy-third-party-row { flex-direction: column; gap: 8px; }
}
`;

  return (
    <>
      <Helmet>
        <title>Privacy Policy — miniDevToolkit</title>
        <meta name="description" content="miniDevToolkit privacy policy. No data collection, no server uploads, no tracking of tool input. All tools run 100% in your browser." />
        <link rel="canonical" href="https://minidevtoolkit.com/privacy" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <style>{css}</style>

      <div className="privacy-page">

        {/* Hero */}
        <div className="privacy-hero">
          <div className="privacy-eyebrow">Legal & Transparency</div>
          <h1 className="privacy-h1">
            Your privacy is<br /><span>not a feature — it's the default.</span>
          </h1>
          <p className="privacy-hero-sub">
            miniDevToolkit is built on a simple principle: your data belongs to you. Every tool
            runs entirely in your browser. Nothing is ever transmitted to our servers, because
            we don't have any servers that process your data.
          </p>
          <div className="privacy-badges">
            <span className="privacy-badge">🔒 Zero Data Collection</span>
            <span className="privacy-badge">🚫 No Server Uploads</span>
            <span className="privacy-badge">🙅 No Account Required</span>
            <span className="privacy-badge">✓ Verifiable in DevTools</span>
          </div>
        </div>

        {/* Core Commitment */}
        <div className="privacy-section-title">Core Commitment</div>

        <div className="privacy-card">
          <div className="privacy-card-icon">🔐</div>
          <div className="privacy-card-title">What we collect</div>
          <p><strong style={{ color: t.textPrimary }}>Absolutely nothing from your tool usage.</strong></p>
          <ul>
            <li>Your JSON, text, files, passwords, and hashes are never sent anywhere</li>
            <li>No tool input or output is stored on any server</li>
            <li>No account, email, or personal information is required</li>
            <li>No cookies are set for tracking or identification</li>
            <li>No fingerprinting or behavioral analytics on tool usage</li>
          </ul>
        </div>

        <div className="privacy-card">
          <div className="privacy-card-icon">💾</div>
          <div className="privacy-card-title">What stays in your browser (localStorage)</div>
          <p>
            A small number of preferences are saved to your browser's <code>localStorage</code> so the
            site remembers your settings between visits. These never leave your device:
          </p>
          <ul>
            <li><code>mdt-theme</code> — dark or light mode preference</li>
            <li><code>mdt-sidebar</code> — sidebar open/collapsed state</li>
            <li><code>mdt-exports</code> — export event metadata (tool name, row count, timestamp — no raw data)</li>
            <li><code>mdt-json-history</code> — JSON export metadata only (no actual JSON content stored)</li>
            <li><code>mdt-fake-history</code> — fake data config metadata only (no generated data stored)</li>
          </ul>
          <p>
            You can clear all of this at any time via your browser's developer tools
            (Application → Storage → localStorage → minidevtoolkit.com → Clear All).
          </p>
        </div>

        <div className="privacy-card">
          <div className="privacy-card-icon">⚡</div>
          <div className="privacy-card-title">How the tools work</div>
          <p>
            All 25+ tools execute their logic entirely using JavaScript in your browser tab.
            When you paste JSON, upload a file, or type a password — that data is loaded into
            browser memory and processed locally. It is never transmitted over a network.
          </p>
          <p>
            For tools that require libraries (PDF conversion, QR code generation), those libraries
            are downloaded from public CDN servers <em>once</em> — but your <strong>document content</strong> is
            never sent to those servers. Only the library code itself is fetched.
          </p>
        </div>

        {/* How to Verify */}
        <div className="privacy-section-title">Verify It Yourself</div>

        <div className="privacy-verifier">
          <div className="privacy-verifier-title">How to confirm no data leaves your browser</div>
          <ol className="privacy-verifier-steps">
            <li>Open any miniDevToolkit tool in your browser</li>
            <li>Open DevTools: <strong>F12</strong> (Windows / Linux) or <strong>Cmd+Option+I</strong> (Mac)</li>
            <li>Click the <strong>Network</strong> tab and filter by <strong>XHR / Fetch</strong></li>
            <li>Paste your data into the tool and run the conversion</li>
            <li>Observe: <strong>zero outbound requests</strong> containing your data appear in the Network tab</li>
          </ol>
        </div>

        {/* Third Parties */}
        <div className="privacy-section-title">Third-Party Services</div>

        <div className="privacy-card" style={{ padding: "20px 24px" }}>
          <p style={{ marginBottom: 16 }}>
            We use a minimal set of third-party services. None of them receive your tool input data.
          </p>

          <div className="privacy-third-party-row">
            <div>
              <div className="privacy-tpr-name">Google Fonts</div>
              <div className="privacy-tpr-desc">
                Loads Poppins and JetBrains Mono typefaces. Google may log the request IP and user-agent.
                No tool data is involved.
              </div>
            </div>
            <span className="privacy-tpr-badge badge-external">External</span>
          </div>

          <div className="privacy-third-party-row">
            <div>
              <div className="privacy-tpr-name">Google AdSense</div>
              <div className="privacy-tpr-desc">
                Displays ads to keep the site free. AdSense may use cookies for ad personalisation
                per Google's own privacy policy. No tool input data is shared.
              </div>
            </div>
            <span className="privacy-tpr-badge badge-external">Advertising</span>
          </div>

          <div className="privacy-third-party-row">
            <div>
              <div className="privacy-tpr-name">Vercel Analytics</div>
              <div className="privacy-tpr-desc">
                Anonymised page-view analytics (page path, country, device type). No personal
                identifiers. No tool input data. Compliant with GDPR.
              </div>
            </div>
            <span className="privacy-tpr-badge badge-analytics">Analytics</span>
          </div>

          <div className="privacy-third-party-row">
            <div>
              <div className="privacy-tpr-name">CDN Libraries (cdnjs, jsDelivr)</div>
              <div className="privacy-tpr-desc">
                PDF.js, jsPDF, mammoth.js, QRCode.js and fflate are fetched from public CDNs
                on first use. Only the library file is downloaded — your documents never leave
                the browser.
              </div>
            </div>
            <span className="privacy-tpr-badge badge-cdn">CDN</span>
          </div>
        </div>

        {/* Security Headers */}
        <div className="privacy-section-title">Security Measures</div>

        <div className="privacy-card">
          <div className="privacy-card-icon">🛡️</div>
          <div className="privacy-card-title">Deployed security headers</div>
          <p>Every response from minidevtoolkit.com is sent with the following HTTP security headers:</p>
          <ul>
            <li><code>Content-Security-Policy</code> — restricts which origins can load scripts, styles, and frames</li>
            <li><code>Strict-Transport-Security</code> — enforces HTTPS for 2 years with preload</li>
            <li><code>X-Content-Type-Options: nosniff</code> — prevents MIME-type sniffing attacks</li>
            <li><code>X-Frame-Options: SAMEORIGIN</code> — blocks clickjacking via iframes</li>
            <li><code>Referrer-Policy: strict-origin-when-cross-origin</code> — limits referrer leakage</li>
            <li><code>Permissions-Policy</code> — disables camera, microphone, geolocation, and interest-cohort</li>
          </ul>
        </div>

        {/* Contact & Updates */}
        <div className="privacy-section-title">Contact & Updates</div>

        <div className="privacy-card">
          <div className="privacy-card-icon">✉️</div>
          <div className="privacy-card-title">Questions or concerns</div>
          <p>
            If you have any questions about this privacy policy or how miniDevToolkit handles
            data, contact the maintainer directly:
          </p>
          <p>
            <a href="mailto:aqibjaved520@gmail.com"
              style={{ color: t.textAccent, fontWeight: 700, textDecoration: "none" }}>
              aqibjaved520@gmail.com
            </a>
          </p>
          <p style={{ marginTop: 14, fontSize: 12, color: t.textMuted }}>
            <em>Last updated: April 2026. This policy may be updated to reflect changes in
            third-party services or site features. The core commitment — no server-side
            processing of your data — will never change.</em>
          </p>
        </div>

        {/* Footer nav */}
        <nav className="privacy-footer-nav" aria-label="Related pages">
          <Link to="/">← Home</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/exports">Export History</Link>
        </nav>

      </div>
    </>
  );
}
